import moment from 'moment';
import React from 'react';
import Datetime from 'react-datetime';
import styled, { CSSProp } from 'styled-components';
import FA from './FontAwesome';

type Props = {
  validType?: 'validAfterToday' | 'invalidAfterToday' | 'none';
  onChange?: (date: moment.Moment | null) => void;
  showIcon?: boolean;
  wrapperStyles?: CSSProp;
} & Omit<React.ComponentPropsWithoutRef<typeof Datetime>, 'onChange'>;

const StyledDatetime = styled(Datetime)`
  margin-bottom: 10px;
`;

const Wrapper = styled.div<{ styles?: CSSProp }>`
  position: relative;
  ${(props) => props.styles}
`;

const Icon = styled(FA)`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  opacity: 0.5;
  pointer-events: none;
  font-size: 24px;
`;

const DateTime = ({
  value,
  onChange,
  validType = 'none',
  timeFormat = 'HH:mm:ss',
  showIcon = false,
  className,
  wrapperStyles,
  ...rest
}: Props) => {
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'days').startOf('day');

  const isValidAfterToday = (date: moment.Moment) => date.isAfter(yesterday);
  const isInvalidAfterToday = (date: moment.Moment) => date.isSameOrBefore(today, 'day');

  const child = (
    <StyledDatetime
      locale="ja-JP"
      onChange={(date) => {
        if (typeof date === 'object') {
          onChange?.(date);
        } else {
          onChange?.(null);
        }
      }}
      value={value}
      timeFormat={timeFormat}
      isValidDate={(date) => {
        if (validType === 'validAfterToday') {
          return isValidAfterToday(date);
        } else if (validType === 'invalidAfterToday') {
          return isInvalidAfterToday(date);
        }

        return true;
      }}
      className={`${className} notranslate`}
      {...rest}
    />
  );

  return showIcon ? (
    <Wrapper styles={wrapperStyles}>
      {child}
      <Icon icon="calendar-alt" />
    </Wrapper>
  ) : (
    child
  );
};

export default styled(DateTime)``;
